module.exports = __webpack_public_path__ + "img/RUN-MIDFOOT-A-GAUCHE.b010bdbd.svg";